"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _storePoint = require("@/api/storePoint");
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _systemConfig = require("@/api/systemConfig");
var _index = _interopRequireDefault(require("../../../../appSetting/wxAccount/wxTemplate/index"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'index',
  components: {
    Templates: _index.default
  },
  // props: {
  //   children: 'child',
  //   label: 'name',
  //   value: 'name'
  // },
  data: function data() {
    var _this2 = this;
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };
    var validateUpload = function validateUpload(rule, value, callback) {
      if (!_this2.ruleForm.image) {
        callback(new Error('请上传提货点logo'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogFormVisible: false,
      modalMap: false,
      keyUrl: '',
      addresData: [],
      ruleForm: {
        name: '',
        introduction: '',
        phone: '',
        address: '',
        detailedAddress: '',
        dayTime: '',
        image: '',
        latitude: ''
      },
      id: 0,
      dayTime: ['', ''],
      rules: {
        name: [{
          required: true,
          message: '请输入提货点名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请选择提货点地址',
          trigger: 'change'
        }],
        dayTime: [{
          required: true,
          type: 'array',
          message: '请选择提货点营业时间',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        detailedAddress: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          validator: validateUpload,
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.ruleForm.image = '';
    var cityList = JSON.parse(sessionStorage.getItem('cityList'));
    this.addresData = cityList;
    this.getCityList();
    this.getKey();
  },
  mounted: function mounted() {
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;
      if (loc && loc.module === 'locationPicker') {
        // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        window.parent.selectAdderss(loc);
      }
    }, false);
    window.selectAdderss = this.selectAdderss;
  },
  methods: {
    //详情
    getInfo: function getInfo(id) {
      var _this3 = this;
      var that = this;
      that.id = id;
      this.loading = true;
      (0, _storePoint.storeInfoApi)({
        id: id
      }).then(function (res) {
        that.ruleForm = res;
        that.ruleForm.address = res.address.split(',');
        that.dayTime = res.dayTime.split(',');
        _this3.loading = false;
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.ruleForm.image = '';
      this.resetForm('ruleForm');
      this.id = 0;
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 提交
    submitForm: (0, _validate.Debounce)(function (name) {
      var _this4 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _storePoint.storeSaveApi)(_this4.ruleForm).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this4.$message.success('提交成功');
                  _this4.dialogFormVisible = false;
                  _this4.$parent.tableList();
                  _this4.$parent.storeGetCount();
                  _this4.clearFrom();
                  _this4.resetForm(name);
                  _this4.id = 0;
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          })));
        } else {
          return false;
        }
      });
    }),
    //编辑
    editForm: (0, _validate.Debounce)(function (name) {
      var _this5 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this5.handleChange(_this5.ruleForm.address);
          (0, _storePoint.storeUpdateApi)(_this5.ruleForm, _this5.id).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this5.$message.success('编辑成功');
                  _this5.dialogFormVisible = false;
                  _this5.$parent.tableList();
                  _this5.clearFrom();
                  _this5.resetForm(name);
                  _this5.id = 0;
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          })));
        } else {
          return false;
        }
      });
    }),
    //数据归为初始状态
    clearFrom: function clearFrom() {
      this.ruleForm.introduction = '';
      this.dayTime = ['', ''];
    },
    //确认省市区
    handleChange: function handleChange(e) {
      var province = e[0];
      var city = e[1];
      var area = e[2];
      if (e.length === 2) {
        this.ruleForm.address = province + ',' + city;
      } else if (e.length === 3) {
        this.ruleForm.address = province + ',' + city + ',' + area;
      }
    },
    //营业时间
    onchangeTime: function onchangeTime(e) {
      this.ruleForm.dayTime = e ? e.join(',') : '';
    },
    //上传图片
    modalPicTap: function modalPicTap(tit) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.ruleForm.image = img[0].sattDir;
      }, tit, 'system');
    },
    //查找位置
    onSearch: function onSearch() {
      this.modalMap = true;
    },
    // 选择经纬度
    selectAdderss: function selectAdderss(data) {
      this.ruleForm.latitude = data.latlng.lng + ',' + data.latlng.lat;
      this.modalMap = false;
    },
    // key值
    getKey: function getKey() {
      var _this6 = this;
      (0, _systemConfig.getTxMapKeyApi)().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          var keys;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                keys = res.value;
                _this6.keyUrl = "https://apis.map.qq.com/tools/locpicker?type=1&key=".concat(keys, "&referer=myapp");
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    getCityList: function getCityList() {
      var _this7 = this;
      logistics.cityListTree().then(function (res) {
        sessionStorage.setItem('cityList', JSON.stringify(res));
        var cityList = JSON.parse(sessionStorage.getItem('cityList'));
        _this7.addresData = cityList;
      }).catch(function (res) {
        _this7.$message.error(res.message);
      });
    }
  }
};